export const categories = [
    {
        id: 0,
        category: "Agriculture",
        description: "Empower farmers and researchers by capturing real-time images of crops, pests, and soil to drive sustainable farming and food security.",
        image: "/images/categories/agriculture.jpg",
        items: [
            {
                id:0,
                name: "Drought-Stressed Crops",
                images: [
                    "/images/categoryOne/One.jpg",
                    "/images/categoryOne/Two.jpg",
                    "/images/categoryOne/Three.jpg",
                    "/images/categoryOne/Four.jpg"
                ],
                question: "Do these crops show signs of drought stress?"
            },
            {
                id:1,
                name: "Pest-Infested Crops",
                images: []
            },
            {
                id:2,
                name: "Weed Growth Patterns",
                images: []
            },
        ]
    },
    {
        id: 1,
        category: "Pets",
        description: "Document pet health, behavior, and environments to support studies in animal welfare, genetics, and urban wildlife.",
        image: "/images/categories/pet.jpg",
        items: [
            {
                id:0,
                name: "Close-up shots of pets' teeth",
                images: []
            },
            {
                id:1,
                name: "Pets engaging with toys",
                images: []
            },
            {
                id:2,
                name: "Pets with skin conditions",
                images: []
            },
        ]
    },
    {
        id: 2,
        category: "Climate & Weather",
        description: "Track weather patterns, pollution, and natural phenomena through user-generated photos for climate change and environmental research.",
        image: "/images/categories/climate.jpg",
        items: [
            {
                id:0,
                name: "Cloud Types",
                images: [
                    "/images/categoryThree/One.jpg",
                    "/images/categoryThree/Two.jpg",
                    "/images/categoryThree/Three.jpg",
                    "/images/categoryThree/Four.jpg"
                ],
                question: "Does it seem to rain soon?"
            },
            {
                id:1,
                name: "Intense heat waves",
                images: []
            },
            {
                id:2,
                name: "Drought Land",
                images: [
                    "",
                    "",
                    "",
                    "",
                    ""
                ]
            },
        ]
    },
    {
        id: 3,
        category: "Urban Development",
        description: "Capture urban landscapes, infrastructure, and societal trends to aid studies in city planning, housing, and sustainable growth.",
        image: "/images/categories/urban.jpg",
        items: [
            {
                id:0,
                name: "Broken roads & bridges",
                images: [
                    "/images/categoryFour/One.jpg",
                    "/images/categoryFour/Two.jpg",
                    "/images/categoryFour/Three.jpg",
                    "/images/categoryFour/Four.jpg"
                ],
                question: "Is the road completely inaccessible?"
            },
            {
                id:1,
                name: "Traffic Congestion",
                images: []
            },
            {
                id:2,
                name: "Solar Panel Installations",
                images: []
            },
        ]
    },
]